import { useTranslation } from 'react-i18next'
import { GlobalContentContainer, BigText, SectionTitle } from '../../../App.styled'
import {
  Section,
  SectionContainer,
  SectionContent,
  Card,
  CardHeading,
  CardText
} from './styled'
import { colors } from '../../../helpers/consts'

import cardImgOne from "../../../images/main-page/card_1.svg";
import cardImgTwo from "../../../images/main-page/card_2.svg";
import cardImgThree from "../../../images/main-page/card_3.svg";

const SystemSection = () => {
  const { t } = useTranslation()

  return (
    <Section>
      <GlobalContentContainer>
        <SectionContainer>
          <SectionTitle>{t('PAGE_MAIN.SYSTEM')}</SectionTitle>
         
          <SectionContent>
            <Card>
              <img src={cardImgOne} alt='' />
              <CardHeading>{t('PAGE_MAIN.SYSTEM.CARD_INFO')}</CardHeading>
              <CardText>{t('PAGE_MAIN.SYSTEM.CARD_TEXT')}</CardText>
            </Card>

            <Card dark color={colors.white}>
              <img src={cardImgTwo} alt='' />
              <CardHeading>{t('PAGE_MAIN.SYSTEM.CARD_INFO_2')}</CardHeading>
              <CardText>{t('PAGE_MAIN.SYSTEM.CARD_TEXT_2')}</CardText>
            </Card>

            <Card dark color={colors.lightBlue}>
              <img src={cardImgThree} alt='' />
              <CardHeading>{t('PAGE_MAIN.SYSTEM.CARD_INFO_3')}</CardHeading>
              <CardText>{t('PAGE_MAIN.SYSTEM.CARD_TEXT_3')}</CardText>
            </Card>
          </SectionContent>

          <BigText>{t('PAGE_MAIN.SYSTEM.TEXT')}</BigText>
        </SectionContainer>
      </GlobalContentContainer>
    </Section>
  )
}

export default SystemSection
